/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCcDinersClub = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14.7 11.993a3.662 3.662 0 0 0-3.657-3.665 3.669 3.669 0 0 0-3.665 3.665 3.673 3.673 0 0 0 3.665 3.665 3.667 3.667 0 0 0 3.658-3.665zm-2.828 2.167V9.826a2.32 2.32 0 0 1 0 4.334zm-1.658 0a2.32 2.32 0 0 1 0-4.334z" />
        <path d="M2 4h20v16H2zm9.036 12h1.884c2.181.014 4.181-1.782 4.181-3.964 0-2.385-2-4.036-4.181-4.036h-1.884C8.818 8 7 9.651 7 12.036c0 2.182 1.818 3.978 4.036 3.964z" />
      </g>
    </g>
  </Icon>
);
export { SvgCcDinersClub as CcDinersClub };
